export const getAuthToken = (): string | null => localStorage.getItem('setKeyUser');

export interface DecodedToken {
  sub?: string;
  email?: string;
  role?: string;
  nameid?: string;
}

const base64UrlDecode = (input: string): string => {
  let base64 = input.replace(/-/g, '+').replace(/_/g, '/');
  while (base64.length % 4) base64 += '=';
  const decoded = atob(base64);
  try {
    return decodeURIComponent(escape(decoded));
  } catch {
    return decoded;
  }
};

export const decodeToken = (token: string): DecodedToken | null => {
  try {
    const payload = token.split('.')[1];
    if (!payload) return null;
    const json = base64UrlDecode(payload);
    return JSON.parse(json) as DecodedToken;
  } catch {
    return null;
  }
};

export const getCurrentUser = (): { userName: string; email: string } | null => {
  const token = getAuthToken();
  if (!token) return null;
  const decoded = decodeToken(token);
  if (!decoded) return null;
  return {
    userName: decoded.sub || 'Usuário Logado',
    email: decoded.email || 'usuario@bylust.com',
  };
};
